/* unplugin-vue-components disabled */import script from "./International_2.vue?vue&type=script&setup=true&lang=ts"
export * from "./International_2.vue?vue&type=script&setup=true&lang=ts"

import "./International_2.vue?vue&type=style&index=0&id=58f9258e&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58f9258e"]])

export default __exports__